'use client';
import React from 'react';
import styles from '../Header.module.scss';
import cx from 'classnames';
import {useScrollDirection} from '@cat-ecom/pcc-components';
const MobileScrollAwareHeader = ({
  equipmentSection,
  searchSection,
  children
}: {
  equipmentSection?: React.ReactNode;
  searchSection?: React.ReactNode;
  children: React.ReactNode;
}) => {
    const scrollDirection = useScrollDirection();
  const isHidden = scrollDirection === 'down';

  return (
    <>
      <div
        className={cx(styles['mobile-scroll-aware-container'], {
          [styles['mobile-scroll-aware-container--hidden']]: isHidden,
          [styles['mobile-scroll-aware-container--visible']]: !isHidden
        })}
      >
        {children}
      </div>
      <div
        className={cx({
          'mt-3 mb-2': isHidden
        })}
      >
        {searchSection}
      </div>

      <div
        className={cx(styles['mobile-scroll-aware-container'], {
          [styles['mobile-scroll-aware-container--hidden']]: isHidden,
          [styles['mobile-scroll-aware-container--visible']]: !isHidden
        })}
      >
        {equipmentSection}
      </div>
    </>
  );
};

export default MobileScrollAwareHeader;
